module.exports = __webpack_public_path__ + "img/P36-en.f8d4853b.png";